module.exports = __webpack_public_path__ + "img/ozo_logo_f.8e28af7e.png";